import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4dcd5002&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=4dcd5002&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd5002",
  null
  
)

export default component.exports